/** Redash result cache TTL for Activity queries in production (seconds). */
export const ACTIVITY_DEFAULT_MAX_AGE_SEC = 180;

/** Bypass Redash cache on local/dev API hosts; use 3m cache in production. */
export function getActivityRedashMaxAge(
  apiUrl: string | undefined = process.env.REACT_APP_API_URL
): number {
  const normalized = (apiUrl || '').toLowerCase();
  if (!normalized || normalized.includes('localhost') || normalized.includes('-dev')) {
    return 0;
  }
  return ACTIVITY_DEFAULT_MAX_AGE_SEC;
}
